import { render, staticRenderFns } from "./CodOrder.vue?vue&type=template&id=3d0e84f8&scoped=true&"
import script from "./CodOrder.vue?vue&type=script&lang=js&"
export * from "./CodOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0e84f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d0e84f8')) {
      api.createRecord('3d0e84f8', component.options)
    } else {
      api.reload('3d0e84f8', component.options)
    }
    module.hot.accept("./CodOrder.vue?vue&type=template&id=3d0e84f8&scoped=true&", function () {
      api.rerender('3d0e84f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Automation/CodOrder.vue"
export default component.exports